module.exports = __webpack_public_path__ + "static/media/privacy-2023-5.8f4d8c8b.webp";